import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { IconButton } from '@chakra-ui/react';
function ChakraIconButton(props) {
    const { icon, iconType, uiSchema, registry, ...otherProps } = props;
    return _jsx(IconButton, { "aria-label": props.title, ...otherProps, icon: icon });
}
ChakraIconButton.displayName = 'ChakraIconButton';
export default memo(ChakraIconButton);
//# sourceMappingURL=ChakraIconButton.js.map